import script from "./ActiveCallView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActiveCallView.vue?vue&type=script&setup=true&lang=ts"

import "./ActiveCallView.vue?vue&type=style&index=0&id=26c2e7a6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c2e7a6"]])

export default __exports__